module.exports = __webpack_public_path__ + "static/media/gchat_step-2.83bafe0a.svg";